import {
  currencyColumn,
  dateColumn,
  defaultColumn,
  expanderColumn,
  linkColumn
} from '../components/ContactList/ColumnDefinitions';

const makeReactColumns = (serverColumns, additionalColumns) => {
  const reactColumns = [];

  for (let x = 0; x < serverColumns.length; x++) {
    const column = serverColumns[x];
    const params = {
      header: column['header'],
      type: column['column_type'],
      value: column['ui_value'] || column['value'] || column['id'],
      link: column['link'],
      subRowValue: column['sub_row_value'],
      fontAwesomeIcon: column['fa_icon'],
      columnClassNames: column['id']
    };
    if (column.column_type === 'expander') {
      reactColumns.push(expanderColumn({}));
    } else if (column.column_type === 'date') {
      reactColumns.push(dateColumn(params));
    } else if (column.column_type === 'link') {
      reactColumns.push(linkColumn(params));
    } else if (column.column_type === 'currency') {
      reactColumns.push(currencyColumn(params));
    } else {
      reactColumns.push(defaultColumn(params));
    }
  }
  reactColumns.push(...additionalColumns);
  return reactColumns;
};

export {
  makeReactColumns
};
